import { RestfulModel } from 'app/model';
import { PartnerMapQuery } from 'app/model/cris/partner-map-query';
import { ModelWithoutId } from 'app/type';

export interface PartnerMapUnion extends RestfulModel<number> {
    active: boolean;
    remarks: string;
    queries: PartnerMapQuery[];
    // temp storage during creation
    desiredPartId?: number;
}

export const newPartnerMapUnion = (): ModelWithoutId<PartnerMapUnion> => ({
    active: true,
    remarks: '',
    queries: [],
});
